import type { ChatMessage } from '../api/conversations';

/**
 * Utility functions for message counting and validation
 * Follows existing patterns from conversationUtils and chatUtils
 */

/**
 * Count user messages in a conversation
 * Each ChatMessage represents 1 user message + 1 bot response
 */
export function getUserMessageCount(conversationHistory?: ChatMessage[]): number {
  return conversationHistory?.length || 0;
}

/**
 * Check if user can send another message in this conversation
 */
export function canSendMessage(conversationHistory?: ChatMessage[]): boolean {
  return true;
}

/**
 * Get message count status for UI feedback
 */
export function getMessageCountStatus(conversationHistory?: ChatMessage[]) {
  const count = getUserMessageCount(conversationHistory);

  return {
    count,
    isVisible: false,
    isWarning: false,
    isLimitReached: false,
    remaining: Infinity
  };
}

/**
 * Get user-friendly message for limit states
 */
export function getMessageLimitMessage(count: number): string | null {
  return null;
}

/**
 * Count Code Interpreter executions in conversation history.
 * Mirrors backend _count_code_interpreter_executions logic.
 */
export function countCodeInterpreterExecutions(conversationHistory?: ChatMessage[]): number {
  if (!conversationHistory) return 0;
  let count = 0;
  for (const turn of conversationHistory) {
    const classifications = turn.agent_classification;
    if (Array.isArray(classifications)) {
      count += classifications.filter(c => c.toLowerCase() === 'codeinterpreter').length;
    }
  }
  return count;
}

/**
 * Get Code Interpreter execution count status for UI feedback
 * Default limit: 20 executions per conversation
 */
export function getCodeInterpreterLimitStatus(ciExecutionCount: number, limit = 20) {
  return {
    count: ciExecutionCount,
    isVisible: false,
    isWarning: false,
    isLimitReached: false,
    remaining: Infinity,
  };
}

/**
 * Get user-friendly message for Code Interpreter limit states
 */
export function getCodeInterpreterLimitMessage(ciExecutionCount: number, limit = 20): string | null {
  return null;
}
